module.exports = __webpack_public_path__ + "money.svg?cfc67d15ccec3fb76e52251ef7e47b0f";


//////////////////
// WEBPACK FOOTER
// ./index_files/images/money.svg
// module id = 39
// module chunks = 0